import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getShiftListApi,
  gettripoptiondata,
  createtrip,
} from "../../../services/TransportService";
import { FaBus, FaUserTie } from "react-icons/fa";
const formatTo12Hour = (timeStr) => {
  const [hour, minute] = timeStr.split(":").map(Number);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${String(minute).padStart(2, "0")} ${ampm}`;
};

const addMinutes = (timeStr, minutesToAdd) => {
  const [hours, minutes] = timeStr.split(":").map(Number);
  const totalMinutes = hours * 60 + minutes + minutesToAdd;

  const newHours = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
  const newMinutes = String(totalMinutes % 60).padStart(2, "0");

  return `${newHours}:${newMinutes}`;
};
const recommendedBuses = [
  { id: 1, number: "OD-02-1234", model: "Tata Marcopolo" },
  { id: 2, number: "OD-05-4567", model: "Ashok Leyland" },
  { id: 3, number: "OD-10-7890", model: "Volvo AC" },
];

const recommendedDrivers = [
  { id: 1, name: "Ramesh Sahu" },
  { id: 2, name: "Sanjay Meher" },
  { id: 3, name: "Prakash Nayak" },
];
const AddTripModal = ({
  modalOpen,
  toggleModal,
  handleAfterSubmit,
  routeId,
  end_time,
}) => {
  const [timemsg, setTimemsg] = useState("");
  const [endtime, setEndtime] = useState("");
  const [createtriploading, setCreatettriploading] = useState(false);
  const [triperrormsg, setTriperrormsg] = useState("");
  const [optionloading, setOptionloading] = useState(false);
  const [showoption, setShowoption] = useState(false);
  const [busoption, setBusoption] = useState([]);
  const [driveroption, setDriveroption] = useState([]);
  const [selectedBus, setSelectedbus] = useState(null);
  const [selecteddriver, setSelecteddriver] = useState(null);
  const [shiftoption, setShiftoption] = useState([]);
  const [selecetdShift, setSelectedShift] = useState(null);
  const [starttime, setStarttime] = useState("");
  const [tripmode, setTripmode] = useState("");
  const [timeConfirmed, setTimeConfirmed] = useState(false);
  const [tripform, settripform] = useState({
    trip_mode: "",
    shift_id: "",
    bus_id: "",
    driver_id: "",
    start_time: "",
  });
  const [errorform, setErrorform] = useState({
    trip_mode: "",
    shift_id: "",
    bus_id: "",
    driver_id: "",
    start_time: "",
  });

  const gettripdata = () => {
    setOptionloading(true);
    gettripoptiondata(routeId, {
      shift_id: tripform.shift_id,
      start_time: tripform.start_time,
      trip_mode: tripform.trip_mode,
    })
      .then((res) => {
        const bus = res?.data?.data.available_buses;
        const optionbus = bus.map((data) => ({
          label: data.number_plate,
          value: data.id,
        }));
        const driver = res?.data?.data.available_drivers;
        const optiondriver = driver.map((data) => ({
          label: data.name,
          value: data.id,
        }));
        setBusoption(optionbus || []);
        setDriveroption(optiondriver || []);
        setSelectedbus(null);
        setSelecteddriver(null);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setOptionloading(false);
      });
  };

  useEffect(() => {
    if (modalOpen) {
      getShiftListApi()
        .then((res) => {
          setShiftoption(res?.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      resettripform();
    }
  }, [modalOpen]);

  useEffect(() => {
    if (timeConfirmed && starttime && tripmode && selecetdShift) {
      gettripdata();
      setShowoption(true);
    } else {
      setBusoption([]);
      setDriveroption([]);
      setSelectedbus(null);
      setSelecteddriver(null);
      setShowoption(false);
    }
  }, [starttime, tripmode, selecetdShift, timeConfirmed]);

  useEffect(() => {
    settripform({
      ...tripform,
      start_time: starttime || "",
      shift_id: selecetdShift?.value || "",
      bus_id: selectedBus?.value || "",
      driver_id: selecteddriver?.value || "",
    });
  }, [starttime, selecetdShift, selectedBus, selecteddriver]);

  const resettripform = () => {
    setEndtime("");
    setTriperrormsg("");
    setShiftoption([]);
    setDriveroption([]);
    setBusoption([]);
    setSelectedbus(null);
    setSelectedShift(null);
    setSelecteddriver(null);
    setStarttime("");
    setTripmode("");
    setOptionloading(false);
    setTimeConfirmed(false);
    setTriperrormsg("");
    settripform({
      trip_mode: "",
      shift_id: "",
      bus_id: "",
      driver_id: "",
      start_time: "",
    });
    setErrorform({
      trip_mode: "",
      shift_id: "",
      bus_id: "",
      driver_id: "",
      start_time: "",
    });
  };

  const handletripform = () => {
    let valid = true;
    const error = {
      trip_mode: "",
      shift_id: "",
      bus_id: "",
      driver_id: "",
      start_time: "",
    };
    if (!tripform?.trip_mode) {
      error.trip_mode = "Mandatory Field";
      valid = false;
    }
    if (!tripform?.shift_id) {
      error.shift_id = "Mandatory Field";
      valid = false;
    }
    if (!tripform?.bus_id) {
      error.bus_id = "Mandatory Field";
      valid = false;
    }
    if (!tripform?.driver_id) {
      error.driver_id = "Mandatory Field";
      valid = false;
    }
    if (!tripform?.start_time) {
      error.start_time = "Mandatory Field";
      valid = false;
    }
    setErrorform(error);
    if (valid) {
      setCreatettriploading(true);
      createtrip(routeId, tripform)
        .then((res) => {
          toggleModal();
          handleAfterSubmit(res?.data?.data || null);
          toast.success("Tripe created successfully");
        })
        .catch((err) => {
          setTriperrormsg(
            err?.reseponse?.data?.message ||
              err?.response?.data?.error ||
              "Please try again later"
          );
        })
        .finally(() => {
          setCreatettriploading(false);
        });
    }
  };

  const getTripStartTimeMinRange = () => {
    const currentShift = shiftoption.find(
      (item) => item.id === selecetdShift?.value
    );
    if (!currentShift) return;
    if (tripmode === "PICKUP") {
      return currentShift?.start_time;
    } else {
      return currentShift?.drop_start_time;
    }
  };

  const getTripStartTimeMaxRange = () => {
    const currentShift = shiftoption.find(
      (item) => item.id === selecetdShift?.value
    );
    if (!currentShift) return;
    if (tripmode === "PICKUP") {
      return currentShift?.end_time;
    } else {
      return currentShift?.drop_end_time;
    }
  };
  const isTimeWithinRange = (time, min, max) => {
    const [h, m] = time.split(":").map(Number);
    const [minH, minM] = min.split(":").map(Number);
    const [maxH, maxM] = max.split(":").map(Number);

    const toMinutes = (h, m) => h * 60 + m;

    const timeMins = toMinutes(h, m);
    const minMins = toMinutes(minH, minM);
    const maxMins = toMinutes(maxH, maxM);

    return timeMins >= minMins && timeMins <= maxMins;
  };
  useEffect(() => {
    if (selecetdShift && tripmode) {
      const min = getTripStartTimeMinRange();
      const max = getTripStartTimeMaxRange();
      setTimemsg(`(${formatTo12Hour(min)} - ${formatTo12Hour(max)})`);
    } else {
      setTimemsg("");
    }
  }, [selecetdShift, tripmode]);
  return (
    <Modal
      show={modalOpen}
      top
      onHide={toggleModal}
      dialogClassName="modal-top"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Trip</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          {triperrormsg && (
            <div className="alert alert-danger">{triperrormsg}</div>
          )}
          <div className="d-flex gap-2">
            <div className="w-50">
              <label className="form-label">Trip Mode</label>
              <div className="d-flex gap-4 justify-content-start">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="routeType"
                    value="PICKUP"
                    id="pickupRadio"
                    checked={tripmode === "PICKUP"}
                    onChange={(e) => {
                      setTripmode(e.target.value);
                      settripform({ ...tripform, trip_mode: e.target.value });
                      setStarttime("");
                      setEndtime("");
                      setTriperrormsg("");
                      setTimeConfirmed(false);
                    }}
                  />
                  <label
                    className="form-check-label text-secondary"
                    style={{ fontWeight: "500" }}
                    htmlFor="pickupRadio"
                  >
                    Pickup
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="routeType"
                    value="DROP"
                    id="dropRadio"
                    checked={tripmode === "DROP"}
                    onChange={(e) => {
                      setTripmode(e.target.value);
                      settripform({ ...tripform, trip_mode: e.target.value });
                      setStarttime("");
                      setEndtime("");
                      setTriperrormsg("");
                      setTimeConfirmed(false);
                    }}
                  />
                  <label
                    className="form-check-label text-secondary"
                    style={{ fontWeight: "500" }}
                    htmlFor="dropRadio"
                  >
                    Drop
                  </label>
                </div>
              </div>
              {errorform?.trip_mode && (
                <small className="text-danger">{errorform?.trip_mode}</small>
              )}
            </div>
            <div className="w-50">
              <label className="form-label">Select Shift</label>
              <Select
                options={shiftoption.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
                onChange={(selected) => {
                  setSelectedShift(selected);
                  setStarttime("");
                  setEndtime("");
                  setTriperrormsg("");
                  setTimeConfirmed(false);
                }}
                placeholder="Shift"
                className="react-select"
                classNamePrefix="select"
                isClearable
                value={selecetdShift}
              />
              {errorform?.shift_id && (
                <small className="text-danger">{errorform?.shift_id}</small>
              )}
            </div>
          </div>
          <div className="d-flex gap-2 mt-1">
            {/* <div className="w-50">
              <label className="form-label">Start Time {timemsg}</label>
              <input
                type="time"
                className="form-control"
                value={starttime}
                min={getTripStartTimeMinRange()}
                max={getTripStartTimeMaxRange()}
                disabled={!tripmode || !selecetdShift}
                onChange={(e) => {
                  const value = e.target.value;
                  const min = getTripStartTimeMinRange();
                  const max = getTripStartTimeMaxRange();
                  console.log(value);
                  if (!isTimeWithinRange(value, min, max)) {
                    setTriperrormsg(
                      `Start time must be between ${formatTo12Hour(
                        min
                      )} and ${formatTo12Hour(max)}`
                    );
                    setStarttime("");
                    setEndtime("");
                    return;
                  }
                  setTriperrormsg("");
                  setStarttime(value);
                  setEndtime(addMinutes(value, parseFloat(end_time || "0")));
                  setTimeConfirmed(false);
                }}
                onBlur={() => {
                  if (starttime) {
                    setTimeConfirmed(true);
                  }
                }}
              />
              {errorform?.start_time && (
                <small className="text-danger">{errorform?.start_time}</small>
              )}
            </div> */}
            <div className="w-50">
              <label className="form-label">Start Time {timemsg}</label>
              <input
                type="time"
                className="form-control"
                value={starttime}
                min={getTripStartTimeMinRange()}
                max={getTripStartTimeMaxRange()}
                disabled={!tripmode || !selecetdShift}
                onChange={(e) => {
                  const value = e.target.value;
                  setStarttime(value); // Just update time on change
                  setTimeConfirmed(false); // mark as unconfirmed
                }}
                onBlur={() => {
                  const min = getTripStartTimeMinRange();
                  const max = getTripStartTimeMaxRange();

                  if (!isTimeWithinRange(starttime, min, max)) {
                    setTriperrormsg(
                      `Start time must be between ${formatTo12Hour(
                        min
                      )} and ${formatTo12Hour(max)}`
                    );
                    setStarttime("");
                    setEndtime("");
                    return;
                  } else {
                    setTriperrormsg("");
                    setEndtime(
                      addMinutes(starttime, parseFloat(end_time || "0"))
                    );
                  }

                  if (starttime) setTimeConfirmed(true);
                }}
              />
              {errorform?.start_time && (
                <small className="text-danger">{errorform.start_time}</small>
              )}
            </div>
            <div className="w-50">
              <label className="form-label">End Time</label>
              <input
                type="time"
                className="form-control"
                value={endtime}
                readOnly
                disabled
              />
            </div>
          </div>
          {optionloading && (
            <div className="d-flex justify-content-center align-items-center mt-3">
              <Spinner animation="border" size="sm" />
              <span className="ms-2">Loading...</span>
            </div>
          )}
          {showoption && !optionloading && (
            <div className="d-flex gap-2 mt-1">
              <div className="w-50">
                <label className="form-label">Select Bus</label>
                <Select
                  options={busoption}
                  onChange={setSelectedbus}
                  placeholder="Bus"
                  className="react-select"
                  classNamePrefix="select"
                  isClearable
                  value={selectedBus}
                />
                {errorform?.bus_id && (
                  <small className="text-danger">{errorform?.bus_id}</small>
                )}
              </div>
              <div className="w-50">
                <label className="form-label">Select Driver</label>
                <Select
                  options={driveroption}
                  onChange={setSelecteddriver}
                  placeholder="Driver"
                  className="react-select"
                  classNamePrefix="select"
                  isClearable
                  value={selecteddriver}
                />
                {errorform?.driver_id && (
                  <small className="text-danger">{errorform?.driver_id}</small>
                )}
              </div>
            </div>
          )}
          {/* <div className="mt-4">
            <h6 className="text-primary mb-2">Suggested Buses:</h6>
            <div className="scroll-container d-flex overflow-auto gap-2 pb-1">
              {recommendedBuses.map((bus) => (
                <div
                  key={bus.id}
                  className="cursor-pointer card bg-light rounded-4 p-1 flex-shrink-0"
                  style={{ minWidth: "160px" }}
                >
                  <div className="d-flex align-items-center">
                    <FaBus className="text-dark me-1 ms-1" size={16} />
                    <span className="text-dark fw-medium small">
                      {bus.number}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-4">
            <h6 className="text-primary mb-2">Suggested Drivers:</h6>
            <div className="scroll-container d-flex overflow-auto gap-3 pb-1">
              {recommendedDrivers.map((driver) => (
                <div
                  key={driver.id}
                  className="cursor-pointer  card bg-light rounded-4 p-1 flex-shrink-0"
                  style={{ minWidth: "170px" }}
                >
                  <div className="d-flex align-items-center">
                    <FaUserTie size={16} className="text-dark me-1 ms-1" />
                    <span className="text-dark fw-medium small">
                      {driver.name}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex w-100 justify-content-center aligin-items-center gap-1">
          <button
            className="btn btn-outline-secondary"
            onClick={toggleModal}
            disabled={createtriploading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handletripform}
            disabled={createtriploading}
          >
            {createtriploading && <Spinner animation="border" size="sm" />}
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddTripModal;
